// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VideoPlayer from 'vue-video-player'
import jwt from "jwt-decode";
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import APlayer from '@moefe/vue-aplayer';
// 引入全局防抖节流
import {throttle,debounce} from './utlis/throttleAndDebounce'
Vue.prototype.$throttle = throttle;
Vue.prototype.$debounce = debounce;
Vue.use(APlayer, {
  defaultCover: 'https://github.com/u3u.png',
  productionTip: true,
});
Vue.use(VideoPlayer)
import App from './App'
import Cookies from "js-cookie";

Vue.use(ElementUI);
Vue.prototype.$Cookies = Cookies
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js